export interface SplitName {
  first: string;
  second: string;
}

// Splits a site name into two lines for the logo, keeping the last two words
// on the second line (e.g. "Apex Auto Spares" -> "Apex" / "Auto Spares",
// "Top gear Auto Spares" -> "Top gear" / "Auto Spares").
export function splitSiteName(name: string): SplitName {
  const trimmed = (name || "").trim();
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length <= 2) return { first: trimmed, second: "" };
  const second = words.slice(-2).join(" ");
  const first = words.slice(0, -2).join(" ");
  return { first, second };
}